import styles from "@stylesheet";
import React, { useEffect, useState } from "react";
import { View, Pressable, Text, useWindowDimensions, Platform } from 'react-native';
import { TextArea } from "tamagui";
import LockModal from "@components/modals/LockModal/LockModal";
import ActiveWidgetComponent from "./Components/ActiveWidgetComponent";
import WidgetSelector from "./Components/WidgetSelector";
import Modal from 'react-native-modal';
import * as Animatable from 'react-native-animatable';
import { themeSelector } from "@reduxLocal/selectors/themeSelector";
import { useDispatch, useSelector } from "react-redux";
import { DefaultRootState } from "@reduxLocal/persistState";
import { CLOSE_SECOND_MENU } from "@reduxLocal/actions/types";
import SpinnerCircle from './Widgets/Components/SpinnerCircleTESTT';
import WidgetList from "./Components/WidgetList";
import { Gesture, GestureDetector } from 'react-native-gesture-handler';
import Animated, {
	useSharedValue,
	withSpring,
	runOnJS
} from 'react-native-reanimated';
//TODO resolve flex containers for elements on Dashboard
const Welcome = ({ navigation }) => {
	const [searchModal, setShowSearchModal] = useState(false);
	const [searchField, setSearchField] = useState('');
	const secondaryMenu = useSelector((state: DefaultRootState) => state.UI.secondaryMenuOpen);
	const [bringUp, setBringUp] = React.useState(false);
	const { height } = useWindowDimensions();

	const theme = themeSelector();
	const dispatch = useDispatch();

	// Gesture handler for swipe up/down
	const panGesture = Gesture.Pan()
		.onUpdate((event) => {
			if (event.translationY < -50) {
				// upward swipe
				runOnJS(setBringUp)(true);
			} else if (event.translationY > 50 && bringUp) {
				// downward swipe
				runOnJS(setBringUp)(false);
			}
		});

	useEffect(() => {
		if (secondaryMenu) {
			dispatch({ type: CLOSE_SECOND_MENU })
		}
	}, [])
	
	const handleTextEntry = (event) => {
		if (event.code === 'Space' && event.ctrlKey) {
			setShowSearchModal(true)
		} else if (event.code === 'Escape') {
			setShowSearchModal(false)
		}
	}

	return (
		<View style={[
			styles.screen,
			{ 
				padding: 0,				
				flexDirection: 'row',
				flex: 1,
				overflow: "hidden",
			}
		]}>
			{/* Widget Selector Sidebar */}
			{window.innerWidth > 900 ? (
			<View style={{
				zIndex: 10,
				maxHeight: "90%",
				minWidth: 80,
				justifyContent: "center",
				flex: 0,
				width: 80,
				alignSelf: 'center',
				backgroundColor: theme
						? 'rgba(255, 255, 255, 0.7)'
						: 'rgba(40, 40, 40, 0.7)',
				borderRadius: 40,
				margin: 16,
				padding: 12,
				alignItems: 'center',
				overflow: 'visible',
				shadowColor: '#000',
				shadowOffset: { width: 0, height: 4 },
					shadowOpacity: theme ? 0.08 : 0.25,
					shadowRadius: 16,
				elevation: 8,
				borderWidth: 1,
				borderColor: theme
						? 'rgba(255, 255, 255, 0.2)'
						: 'rgba(255, 255, 255, 0.1)',
					...(Platform.OS === 'web' && {
						backdropFilter: 'blur(20px)',
						WebkitBackdropFilter: 'blur(20px)',
					}),
				}}>
					<WidgetSelector
						containerStyle={{
							minWidth: 120,
							left: -27,
						}}
						vertical={true}
						userWidgetList={undefined}
					/>
			</View>

			) : <View style={{ 
				position: 'absolute', 
				bottom: "-25%", 
				left: 0,
				right: 0,
				zIndex: 1000 
			}}>
					<GestureDetector gesture={panGesture}>
					<Animated.View style={{ flex: 1 }}>
						<Animatable.View
							transition={['top']}
							style={{
								flex: 1,
								paddingLeft: 37,
								top: bringUp ? -height / 2 : 0,
							}}
						>
							<SpinnerCircle components={WidgetList} open={bringUp} />
						</Animatable.View>
					</Animated.View>
					</GestureDetector>

			</View>}

			<LockModal />

			{/* Enhanced Search Modal */}
			<Modal
				isVisible={searchModal}
				onBackdropPress={() => setShowSearchModal(false)}
				animationIn="slideInDown"
				animationOut="slideOutUp"
				backdropOpacity={0.3}
			>
				<View style={{
					maxHeight: '12%',
					backgroundColor: theme ? 'rgba(255, 255, 255, 0.95)' : 'rgba(40, 40, 40, 0.95)',
					borderRadius: 16,
					elevation: 8,
					shadowColor: '#000',
					shadowOffset: { width: 0, height: 4 },
					shadowOpacity: 0.2,
					shadowRadius: 12,
					borderWidth: 1,
					borderColor: theme
						? 'rgba(0, 0, 0, 0.1)'
						: 'rgba(255, 255, 255, 0.1)',
					padding: 16,
				}}>
					<TextArea
						value={searchField}
						autoFocus
						placeholder="Quick access features"
						onChangeText={value => setSearchField(value)}
						style={{
							backgroundColor: 'transparent',
							borderWidth: 0,
							fontSize: 16,
							color: theme ? '#333' : '#fff',
						}}
						placeholderTextColor={theme ? '#666' : '#999'}
					/>
				</View>
			</Modal>

			{/* Main Content Area */}
			<View style={{
				flex: 1,
				flexDirection: "column",
				marginRight: 16,
				marginBottom: 16,
			}}>
				<React.Suspense fallback={
					<View style={{
						flex: 1,
						alignItems: 'center',
						justifyContent: 'center',
						backgroundColor: theme
							? 'rgba(255, 255, 255, 0.5)'
							: 'rgba(40, 40, 40, 0.5)',
						borderRadius: 16,
						margin: 8,
					}}>
						<Text style={{
							color: theme ? '#666' : '#999',
							fontSize: 16,
						}}>
							Loading...
						</Text>
					</View>
				}>
					<Animatable.View
						useNativeDriver
						animation={'fadeIn'}
						style={{
							flex: 1,
							borderRadius: 16,
							overflow: 'hidden',
							margin: 8,
						}}
					>
						<ActiveWidgetComponent />
					</Animatable.View>
				</React.Suspense>
			</View>
		</View>
	)
};
export default Welcome;